/* eslint-disable import/prefer-default-export */
import { getCookie } from 'utils/cookies';

export function setPageConfigAndSendIBeatCall() {
  if (window.TimesApps.iBeat && window.TimesApps.iBeat.sendIBeatCall) {
    window.TimesApps.iBeat.sendIBeatCall();
  }
}

export function setIbeattrack({
  author,
  contentType,
  msid,
  planStatus,
  publishedDate,
}) {
  const ssoid = getCookie('ssoid') || getCookie('ssoId');
  const _ibeat_track = {
    au: author,
    ct: contentType,
    id: msid,
    pc: ssoid ? planStatus : -1,
    pt: publishedDate
      ? `${Math.floor(new Date(parseInt(publishedDate, 10)).getTime() / 1000)}`
      : '',
  };
  window._ibeat_track = _ibeat_track;
}
